export const DEFAULT_FILTERS = {
    impactScore: {
        label: 'Information Score',
        values: [
            {
                label: '0',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0 ELSE false END", 
            },
            {
                label: '0.05',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.05 ELSE false END", 
            },
            {
                label: '0.1',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.1 ELSE false END", 
            },
            {
                label: '0.15',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.15 ELSE false END", 
            },
            {
                label: '0.2',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.2 ELSE false END", 
            },
            {
                label: '0.25',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.25 ELSE false END", 
            },
            {
                label: '0.3',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.3 ELSE false END", 
            },
            {
                label: '0.35',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.35 ELSE false END", 
            },
            {
                label: '0.4',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.4 ELSE false END", 
            },
            {
                label: '0.45',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.45 ELSE false END", 
            },
            {
                label: '0.5',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.5 ELSE false END", 
            },
            {
                label: '0.55',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.55 ELSE false END", 
            },
            {
                label: '0.6',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.6 ELSE false END", 
            },
            {
                label: '0.65',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.65 ELSE false END", 
            },
            {
                label: '0.7',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.7 ELSE false END", 
            },
            {
                label: '0.75',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.75 ELSE false END", 
            },
            {
                label: '0.8',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.8 ELSE false END", 
            },
            {
                label: '0.85',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.85 ELSE false END", 
            },
            {
                label: '0.9',
                value: "CASE WHEN dtm_summary->'dtm_summary_meta'->'impact_score' != 'null' THEN (dtm_summary->'dtm_summary_meta'->'impact_score')::numeric > 0.9 ELSE false END", 
            },
        ],
    },
    informationScore: {
        label: 'Explanation Information Score',
        values: [
            {
                label: 'Any',
                value: null, 
            },
            {
                label: 'Very Low or Better',
                value: "(dtm_summary->'dtm_summary_meta'->'information_score'->'level')::int >= 1", 
            },
            {
                label: 'Low or Better',
                value: "(dtm_summary->'dtm_summary_meta'->'information_score'->'level')::int >= 2", 
            },
            {
                label: 'Medium or Better',
                value: "(dtm_summary->'dtm_summary_meta'->'information_score'->'level')::int >= 3", 
            },
            {
                label: 'High or Better',
                value: "(dtm_summary->'dtm_summary_meta'->'information_score'->'level')::int >= 4", 
            },
            {
                label: 'Very High or Better',
                value: "(dtm_summary->'dtm_summary_meta'->'information_score'->'level')::int >= 5", 
            },
        ],
    },
    marketReaderHot: {
        label: 'Move Filter',
        values: [
            {
                label: 'Any',
                value: null
            },
            {
                label: 'Unusual Moves Today',
                value: '(date_return_oc_percentile NOT BETWEEN 0.06 AND 0.94) OR (date_range_hl_percentile > 0.95)',
            },
            {
                label: 'Unusual Over 10min',
                value: 'return_oc_percentile NOT BETWEEN 0.01 AND 0.99', 
            },
        ]
    },
    marketCap: {
        label: 'Market Cap',
        values: [
            {
                label: 'Any',
                value: null,
            },
            {
                label: '> 500B',
                value: 'mcap_mm>500000',
            },
            {
                label: '> 100B',
                value: 'mcap_mm>100000',
            },
            {
                label: '> 50B',
                value: 'mcap_mm>50000',
            },
            {
                label: '> 40B',
                value: 'mcap_mm>40000',
            },
            {
                label: '> 30B',
                value: 'mcap_mm>30000',
            },
            {
                label: '> 20B',
                value: 'mcap_mm>20000',
            },
            {
                label: '> 10B',
                value: 'mcap_mm>10000',
            },
            {
                label: '> 5B',
                value: 'mcap_mm>5000',
            },
            {
                label: '> 1B',
                value: 'mcap_mm>1000',
            },
            {
                label: '> 500M',
                value: 'mcap_mm>500',
            },
            {
                label: '> 100M',
                value: 'mcap_mm>100',
            },
        ],
    },
    // unusualVolume: {
    //     label: 'Unusual Volume',
    //     values: [
    //         {
    //             label: 'Any',
    //             value: null,
    //         },
    //         {
    //             label: 'Today',
    //             value: 'date_volume_percentile>0.99',
    //         },
    //         {
    //             label: 'Last 10min',
    //             value: 'volume_percentile>0.99',
    //         },
    //     ],
    // },
};

export const EXPLANATION_FILTERS = {
    explanations: {
        label: 'Explanation Types',
        values: [
            {
                label: 'Analyst Ratings',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Analyst Ratings')"
            },
            {
                label: 'Associated News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Associated News')"
            },
            {
                label: 'Bearish Market Sentiment',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Bearish Market Sentiment')"
            },
            {
                label: 'Bullish Market Sentiment',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Bullish Market Sentiment')"
            },
            {
                label: 'Commodity News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Commodity News')"
            },
            {
                label: 'Company News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Company News')"
            },
            {
                label: 'Company-Specific Activities',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Company-Specific Activities')"
            },
            {
                label: 'Company-Specific Reports',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Company-Specific Reports')"
            },
            {
                label: 'Crypto News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Crypto News')"
            },
            {
                label: 'Currency Effect',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Currency Effect')"
            },
            {
                label: 'Currency News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Currency News')"
            },
            {
                label: 'Earnings',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings')"
            },
            {
                label: 'Earnings Beat',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings Beat')"
            },
            {
                label: 'Earnings Guidance Lowered',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings Guidance Lowered')"
            },
            {
                label: 'Earnings Guidance Reaffirmed',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings Guidance Reaffirmed')"
            },
            {
                label: 'Earnings Guidance Set',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings Guidance Set')"
            },
            {
                label: 'Earnings Missed',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Earnings Missed')"
            },
            {
                label: 'ETF News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'ETF News')"
            },
            {
                label: 'Ex-Dividend',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Ex-Dividend')"
            },
            {
                label: 'FDA',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'FDA')"
            },
            {
                label: 'Financial Metrics',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Financial Metrics')"
            },
            {
                label: 'Future Earnings',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Future Earnings')"
            },
            {
                label: 'Guidance',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Guidance')"
            },
            {
                label: 'High Share of Market Volume',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'High Share of Market Volume')"
            },
            {
                label: 'Legal Disputes',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Legal Disputes')"
            },
            {
                label: 'Licensing Agreement',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Licensing Agreement')"
            },
            {
                label: 'M&A',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'M&A')"
            },
            {
                label: 'Macro Event',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Macro Event')"
            },
            {
                label: 'Macro News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Macro News')"
            },
            {
                label: 'Market Sentiment',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Market Sentiment')"
            },
            {
                label: 'Moving With Broad Market',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Moving With Broad Market')"
            },
            {
                label: 'Moving With Sector',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Moving With Sector')"
            },
            {
                label: 'Options Activity',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Options Activity')"
            },
            {
                label: 'Outperforming Peers',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Outperforming Peers')"
            },
            {
                label: 'Positive Market Movement',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Positive Market Movement')"
            },
            {
                label: 'Pre-Market Trading',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Pre-Market Trading')"
            },
            {
                label: 'Price Target',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Price Target')"
            },
            {
                label: 'Regulatory Changes',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Regulatory Changes')"
            },
            {
                label: 'Revenue',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue')"
            },
            {
                label: 'Revenue Beat',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Beat')"
            },
            {
                label: 'Revenue Guidance Lowered',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Guidance Lowered')"
            },
            {
                label: 'Revenue Guidance Raised',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Guidance Raised')"
            },
            {
                label: 'Revenue Guidance Reaffirmed',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Guidance Reaffirmed')"
            },
            {
                label: 'Revenue Guidance Set',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Guidance Set')"
            },
            {
                label: 'Revenue Missed',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Revenue Missed')"
            },
            {
                label: 'Reverse Split',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Reverse Split')"
            },
            {
                label: 'Sector News',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Sector News')"
            },
            {
                label: 'Sector Strength',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Sector Strength')"
            },
            {
                label: 'Sector Weakness',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Sector Weakness')"
            },
            {
                label: 'Social Media Discussion',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Social Media Discussion')"
            },
            {
                label: 'Split',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Split')"
            },
            {
                label: 'Underperforming Peers',
                value: "(dtm_summary->'dtm_summary_meta'->'tags' ? 'Underperforming Peers')"
            },
        ],
    },
};